import React from 'react';
import {view} from '@sail/ui';

import {StripeAvatar} from '@stripe-internal/conversations-ui';

// With the Stripe Brand, the children (aka message bubble)
// is rendered to the right of the avatar since there is
// no custom text header label.
export const StripeBrandResponse = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  return (
    <view.div
      data-testid="live-answers-support-stripe-brand"
      css={{
        stack: 'x',
        alignY: 'stretch',
        gap: 'small',
        marginRight: 'large',
      }}
    >
      <StripeAvatar />
      <view.div
        data-testid="live-answers-response-content-wrapper"
        css={{
          // Allow child response bubbles grow to fill all available space.
          width: 'fill',
          // In order to support ellipsis text overflow in the sources list we need to
          // set a fixed width here, so we take the parent width minus the width of the
          // other components in the stack (avatar width + column gap).
          maxWidth: 'calc(100% - (28px + var(--column-gap)))',
        }}
      >
        {children}
      </view.div>
    </view.div>
  );
};
